import React from 'react';
import { FaHeadphones, FaImages, FaPhotoVideo } from 'react-icons/fa';
import { PAGE_MEDIA_LIMITS, countPageMedia } from '../services/mediaLimits';

const items = [
  { key: 'images', label: 'Photos', icon: FaImages, limit: PAGE_MEDIA_LIMITS.images },
  { key: 'videos', label: 'Videos', icon: FaPhotoVideo, limit: PAGE_MEDIA_LIMITS.videos },
  { key: 'audios', label: 'Audio', icon: FaHeadphones, limit: PAGE_MEDIA_LIMITS.audios },
];

const MediaUsageMeter = ({ pageData, theme }) => {
  const usage = countPageMedia(pageData);
  const totalPercent = Math.min(100, Math.round((usage.total / PAGE_MEDIA_LIMITS.total) * 100));

  return (
    <div className="rounded-[2rem] border-4 border-white bg-white/45 p-5 shadow-inner">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-[10px] font-black uppercase tracking-[0.28em]" style={{ color: theme.accent }}>
            Media Budget
          </div>
          <p className="mt-2 text-xs font-bold leading-relaxed opacity-60">
            Keep the gift light enough to open quickly on mobile.
          </p>
        </div>
        <div className="rounded-full bg-white/70 px-3 py-1 text-[8px] font-black uppercase tracking-widest opacity-55">
          {usage.total}/{PAGE_MEDIA_LIMITS.total}
        </div>
      </div>

      <div className="mt-4 h-2 overflow-hidden rounded-full bg-white/75">
        <div
          className="h-full rounded-full transition-all"
          style={{
            width: `${totalPercent}%`,
            backgroundColor: totalPercent >= 90 ? '#ef4444' : theme.accent,
          }}
        />
      </div>

      <div className="mt-4 grid grid-cols-3 gap-2">
        {items.map((item) => {
          const Icon = item.icon;
          const used = usage[item.key] || 0;
          const isFull = used >= item.limit;
          return (
            <div key={item.key} className="rounded-[1.25rem] bg-white/65 px-3 py-3 text-center">
              <Icon className="mx-auto mb-2 text-xs" style={{ color: isFull ? '#ef4444' : theme.accent }} />
              <div className="text-[8px] font-black uppercase tracking-widest opacity-55">{item.label}</div>
              <div className="mt-1 text-[10px] font-black" style={{ color: isFull ? '#ef4444' : theme.text }}>
                {used}/{item.limit}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MediaUsageMeter;
